function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.3999 12.0004C2.3999 6.70119 6.7007 2.40039 11.9999 2.40039C17.2991 2.40039 21.5999 6.70119 21.5999 12.0004C21.5999 17.2996 17.2991 21.6004 11.9999 21.6004C6.7007 21.6004 2.3999 17.2996 2.3999 12.0004ZM16.7066 7.64517C16.4486 7.37636 16.0287 7.37471 15.7687 7.64147L9.79116 13.7753L8.04777 11.9727C7.78879 11.7049 7.36891 11.7049 7.10993 11.9727C6.85095 12.2404 6.85095 12.6746 7.10993 12.9424L9.32045 15.2281C9.57873 15.4952 9.99724 15.496 10.2565 15.23L16.703 8.61491C16.963 8.34815 16.9646 7.91398 16.7066 7.64517Z",
  fill: "#1BB4D0"
});
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "2.399899959564209 2.4003899097442627 19.19999885559082 19.200010299682617",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.4ded7898.svg";
export { ForwardRef as ReactComponent };